const authApi = ({ apiClient }) => ({
  login(payload, headers = {}) {
    return apiClient.rawRequest({
      url: 'auth/login',
      method: 'POST',
      body: payload,
      headers,
    })
  },

  logout(token) {
    return apiClient.rawRequest({
      url: 'auth/logout',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  },

  refresh(token) {
    return apiClient.rawRequest({
      url: 'auth/refresh',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  },

  switchTenant(token, realEstateId) {
    return apiClient.rawRequest({
      url: 'auth/switch-tenant',
      method: 'POST',
      body: {
        real_estate_id: realEstateId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  },

  profile(token) {
    return apiClient.rawRequest({
      url: 'auth/profile',
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  },

  realEstates(token) {
    return apiClient.rawRequest({
      url: 'auth/real-estates',
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  },

  loginWithToken(token) {
    return apiClient.rawRequest({
      url: 'auth/login-by-token',
      method: 'POST',
      body: {
        token,
      },
    })
  },

  validateToken(token) {
    return apiClient.rawRequest({
      url: 'auth/validate',
      method: 'POST',
      body: {
        token,
      },
    })
  },
})

export default authApi
